var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCapacity = function SvgCapacity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#capacity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.904 9.429 23.476.857M16.62.857h6.856v6.858M9.762 9.429 1.19.857M8.048.857H1.19v6.858M14.904 14.571l8.572 8.572M16.62 23.143h6.856v-6.857M9.762 14.571 1.19 23.143M8.048 23.143H1.19v-6.857"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "capacity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 0h24v24h-24z"
  })))));
};
export default SvgCapacity;